import styled, { css } from "styled-components";
import flex from "@/utils/flex";
import { desktop, mobile, tablet } from "@/utils/responsive";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: gray;
  width: 100%;
  border: 3px solid var(--black);
`;

export const Main = styled.div`
  display: flex;
  height: 20%;
`;

export const MainTitle = styled.button`
  ${flex({ direction: "column" })}
  width: 100%;
  cursor: pointer;
  background-color: var(--white);
  border: 1px solid var(--black);
  :active {
    background-color: var(--sub);
  }
`;

export const TitleDiv = styled.div<{ big?: boolean }>`
  ${flex({})}
  width: 100%;
  height: 30px;
  background-color: var(--white);
  border-left: 1px solid var(--black);
  border-right: 1px solid var(--black);
  font-weight: 700;
  font-size: ${(props) => (props.big ? "1.1rem" : "0.9rem")};
  .name {
    font-size: 1.2rem;
  }

  // responsive
  ${mobile(css``)}
  ${tablet(css``)}
  ${desktop(css``)}
`;
